import React, { useState } from "react";
import { Dropdown } from "../../common/components/dropdown/Dropdown";
import { Preset } from "./Preset";
import { RequiredRoles } from "../criteria/components/common/requiredRoles";
import { dropdownItemsType } from "../../common/types/search/search";

interface SimpleChoicePresetProps {
	title: string;
	content: string;
	dropdownToggle: string;
	choices?: dropdownItemsType;
	onClick: (value: string) => string;
	errorMessage: string;
	loading?: boolean;
	isVertical?: boolean;
	requiredRoles?: RequiredRoles;
}

export function SimpleChoicePreset({
	title,
	content,
	dropdownToggle,
	choices,
	errorMessage,
	onClick,
	loading,
	isVertical,
	requiredRoles,
}: SimpleChoicePresetProps) {
	const [dropdown, setDropdown] = useState({
		name: dropdownToggle,
		value: undefined,
		error: undefined,
	});
	const link = onClick(dropdown.value);

	const onDropdownItemClick = (key, value) => {
		setDropdown((yearSelected) => ({
			...yearSelected,
			name: value,
			value: key,
			error: undefined,
		}));
	};

	const handleSearchClick = (e) => {
		if (!dropdown.value) {
			e.preventDefault();
			setDropdown((yearSelected) => ({
				...yearSelected,
				error: errorMessage,
			}));
		}
	};

	const error = dropdown.error;

	return (
		<Preset
			title={title}
			content={content}
			link={link}
			onClick={handleSearchClick}
			error={error}
			isVertical={isVertical}
			requiredRoles={requiredRoles}
		>
			<Dropdown
				dropdownToggle={dropdown.name}
				dropdownItems={choices}
				loading={loading}
				onDropdownItemClick={onDropdownItemClick}
				dropdownKey={title}
				label={title}
			/>
			<span className="error-text">{error}</span>
		</Preset>
	);
}
